// Third-party embeds ship inside <template data-consent-embed>, which the browser
// never loads. Swapped in on Consentmo marketing consent, or per embed via the
// placeholder button. Strings come from the script tag's data-* attributes.
(function consentEmbeds() {
  const strings = document.currentScript.dataset;
  // apple/spotify come from rich-text article embeds, not theme files; others fall back to the hostname.
  const names = {youtube: 'YouTube', vimeo: 'Vimeo', apple: 'Apple', spotify: 'Spotify'};
  const boxes = new WeakMap(); // template → its placeholder
  // The head snippet (consentmo-klaviyo) records an early "banner inactive" signal
  // that this deferred script would otherwise miss.
  let granted = !!window.consentmoBannerInactive;

  function cookieAllows() {
    const match = document.cookie.match(/(?:^|;\s*)cookieconsent_preferences_disabled=([^;]*)/);
    return !!match && !decodeURIComponent(match[1]).includes('marketing');
  }

  function provider(frame) {
    const src = frame.getAttribute('src') || frame.getAttribute('data-src') || frame.getAttribute('data-src1');
    const host = new URL(src, document.baseURI).hostname;
    const key = Object.keys(names).find((k) => host.includes(k));
    return key ? names[key] : host;
  }

  function unwrap(template) {
    boxes.get(template)?.remove();
    const parent = template.parentNode;
    template.content.querySelectorAll('iframe[data-src]:not([src])').forEach((frame) => {
      frame.setAttribute('src', frame.getAttribute('data-src'));
    });
    template.replaceWith(template.content);
    // For sections that set src themselves (lazy modals) and may already be open.
    parent.dispatchEvent(new CustomEvent('consentEmbedLoaded', {bubbles: true}));
  }

  function placeholder(template) {
    const frame = template.content.querySelector('iframe');
    if (!frame || boxes.has(template)) return;
    const box = document.createElement('div');
    box.className = 'consent-embed';
    box.innerHTML = '<p></p><button type="button" class="button"></button>';
    box.querySelector('p').textContent = strings.notice.replaceAll('__PROVIDER__', provider(frame));
    box.querySelector('button').textContent = strings.load;
    box.querySelector('button').addEventListener('click', () => unwrap(template));
    boxes.set(template, box);
    template.before(box);
  }

  function render(root) {
    root.querySelectorAll('template[data-consent-embed]').forEach((template) => {
      if (granted || cookieAllows()) unwrap(template);
      else placeholder(template);
    });
  }

  // Banner inactive for this visitor → consent not required.
  document.addEventListener('consentmoSignal_onLoad', (e) => {
    if (!(e.detail || {}).isActive) {
      granted = true;
      render(document);
    }
  });
  // Revoking is covered by the Klaviyo gate, which reloads the page.
  document.addEventListener('consentmoSignal', (e) => {
    if ((e.detail?.preferences || {}).marketing) {
      granted = true;
      render(document);
    }
  });
  document.addEventListener('shopify:section:load', (e) => render(e.target));

  render(document);
})();
